<template>
  <div class="card-padding">
    <div
      v-if="headerTitle"
      class="header-common view-flex view-flex-bottom"
    >
      <div class="main">
        {{ headerTitle.main }}
      </div>
      <div
        class="subtitle"
        @click="handleRoute"
      >
        {{ headerTitle.sub }}
      </div>
    </div>
    <div
      v-if="datastatics"
      class="body view-flex"
    >
      <div
        v-for="(data, index) in datastatics"
        :key="index"
        class="col"
      >
        <LabelDisplay
          :data="data"
          :money-label="money"
          :last="datastatics.length - 1 === index"
        />
      </div>
    </div>
    <slot v-if="lineChart" />
  </div>
</template>

<script>
import LabelDisplay from './LabelDisplay'
export default {
  components: {
    LabelDisplay
  },
  props: {
    headerTitle: {
      type: Object,
      default: () => {}
    },
    datastatics: {
      type: Array,
      default: () => []
    },
    money: {
      type: Boolean,
      default: false
    },
    lineChart: {
      type: Boolean
    },
    viewUrl: {
      type: String
    }
  },
  methods: {
    handleRoute: function () {
      if (!this.viewUrl) {
        return
      }
      this.$router.push(`${this.viewUrl}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-padding {
  padding: 20px;
  background: #fff;
  margin-bottom: 20px;
  .body {
    display: flex;

    .col {
      width: 33.3333%;
      margin-top: 30px;
    }
  }

  &.height190px {
    height: 190px;
  }

  .header-common {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .subtitle {
      margin-left: 30px;
      font-size: 14px;
      color: grey;
      cursor: pointer;
    }
  }
  &.histogram {
    .main {
      font-size: 16px;
      color: black;
      font-weight: 500;
    }
    .sub {
      font-size: 12px;
      color: grey;
    }
    .body {
      margin-top: 36px;
    }
  }
}
@media only screen and (max-width: 1600px) {
  .card-padding {
    padding-bottom: 30px;

    .body {
      display: flex;

      .col {
        margin-top: 20px;
      }
    }

    .header-common {
      .main {
        font-size: 14px;
      }
      .subtitle {
        font-size: 12px;
      }
    }
  }
}
</style>
